// libs/storage.ts
import "client-only";
import { StorageOpts } from "types";

export const tryParseJSON = (str: string | undefined = "", defaultValue = {}) => {
  try {
    return JSON.parse(str);
  } catch {
    return defaultValue;
  }
};

const storage = {
  set: (name: string, value: string, { isJson }: StorageOpts = { isJson: true }) =>
    localStorage.setItem(name, isJson ? JSON.stringify(value) : value),
  get: (
    name: string,
    defaultValue: string | undefined,
    { isJson }: StorageOpts = { isJson: true }
  ) => {
    const res = localStorage.getItem(name) ?? defaultValue;

    if (!isJson) {
      if (res === "true" || res === "false") {
        return res === "true";
      }

      return res;
    }

    return tryParseJSON(res, defaultValue);
  },
  remove: (name: string) => localStorage.removeItem(name),
  clear: () => localStorage.clear(),
};

export default storage;
